import React from 'react';

const Permissions: React.FC = () => {
    const modules = [
        { name: 'contacts', description: 'Access contact records' },
        // 'deals' retained in list for informational purposes — UI may hide related modules
        { name: 'deals', description: 'Manage deals and pipeline' },
        { name: 'users', description: 'User and role management' },
    ];

    return (
        <div className="space-y-6">
            <div>
                <h1 className="text-3xl font-bold tracking-tight">Permissions</h1>
                <p className="text-neutral-400 mt-2">Manage module permissions and access levels.</p>
            </div>

            <div className="bg-neutral-800 border border-neutral-700 rounded p-4">
                <ul className="space-y-2">
                    {modules.map((m) => (
                        <li key={m.name} className="p-3 bg-neutral-900 rounded flex items-center justify-between">
                            <div>
                                <div className="font-medium">{m.name}</div>
                                <div className="text-sm text-neutral-400">{m.description}</div>
                            </div>
                            <div className="text-sm text-neutral-400">Read / Write</div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default Permissions;
